<app-loader
  [apiCall]="this.apiCall"
  [loader]="true"
  [loaderId]="'statusHistoryCreateModal'"
  style="min-height: 150px"
>
  <form
    [formGroup]="form"
    (ngSubmit)="onSubmit()"
    [hasUnsavedData]="form"
  >
    <button type="submit" hidden="hidden"></button>

    <div class="row mb-2">
      <div class="col-12 col-md">

        <div class="form-group row">
          <label class="col-4 col-form-label-sm" translate
          >INSURANCE_CLAIM_STATUS_HISTORY_LBL_FROM_STATUS</label
          >
          <div class="col">
            <input
              class="form-control form-control-sm"
              type="text"
              formControlName="fromStatusLoc"
              checkFormFieldValidity
              [readOnly]="true"
            />
          </div>
        </div>

        <div class="form-group row">
          <label class="col-4 col-form-label-sm" translate
          >INSURANCE_CLAIM_STATUS_HISTORY_LBL_TO_STATUS</label
          >
          <div class="col">
            <input
              class="form-control form-control-sm"
              type="text"
              formControlName="toStatusLoc"
              checkFormFieldValidity
              [readOnly]="true"
            />
          </div>
        </div>

        <div class="form-group row">
          <label class="col-4 col-form-label-sm" translate
          >INSURANCE_CLAIM_STATUS_HISTORY_LBL_CHANGE_DATE</label
          >
          <div class="col">
            <input
              class="form-control form-control-sm"
              type="datetime-local"
              formControlName="changeDate"
              checkFormFieldValidity
            />
          </div>
        </div>

      </div>
    </div>
  </form>
</app-loader>
